var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mt-4 flex-wrap md:flex-nowrap pb-10 md:pb-0"},[_c('form-values',{staticClass:"xl:w-2/5 lg:w-2/5 md:w-80 w-full pb-5",attrs:{"options-inputs":{
            amount: {
                readonly: true,
            },
            description: {
                readonly: true,
                class: 'opacity-60'
            },
            receiver_code: {
                readonly: true,
                class: 'opacity-60'
            }
        },"title":'Preencha os campos',"form":_vm.form},on:{"go-back":function($event){return _vm.$emit('go-back')}}}),_vm._v(" "),_c('form-summary',{staticClass:"flex-1 md:mb-6 lg:mb-0 mb-0",attrs:{"form":_vm.form,"favored":_vm.favoredFormatted},on:{"input":function($event){_vm.form[$event.type] = $event.value},"submit":_vm.transferPix}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }